import { AuthState } from '@okta/okta-auth-js';

import { HedgedCommodity } from '../../services/backend/HedgedCommodity';
import { useBaseApiClient } from '../useBaseApiClient';

export const useHedgedCommodity: () => HedgedCommodity<AuthState> = () => {
  return useBaseApiClient(HedgedCommodity);
};
